module.exports = __webpack_public_path__ + "img/questionmark.79b7681a.svg";